module.exports = __webpack_public_path__ + "media/images/favicon-96x96-2430c3de6a1f39813391246034ec3259.png";